export default {
    corDeFundo: '#7D3C98',
    corDoTexto: '#000',
    corContainerContato: '#F1948A',
    corDasBordas: '#000',
    corBotaoEditar: '#82E0AA',
    corBotaoRemover: 'rgba(232, 65, 24,1.0)',
    corBotaoSalvar: '#45BB89',
    corContainerRemover: 'rgb(255, 255, 255)'
}